<swiper-container #swiper>
  <swiper-slide class="wrapper-onboarding">
    <div class="wrapper-image-onboarding">
      <img src="../assets/images/onboarding-image1.png" alt="">
      <div class="wrapper-steps-btn">
        <div class="step-btn active"></div>
        <div class="step-btn" (click)="goToSlide(1)"></div>
        <div class="step-btn" (click)="goToSlide(2)"></div>
      </div>
      <div class="wrapper-onboarding-text">
        <h1>{{'ONBOARDING.create_your_own_lysts_with_your_favorite_items' | translate}}</h1>
        <h6>
          {{'ONBOARDING.seamlessly_add_entries_to_your_lysts_and_items_with_our_mobile_app_and_remember_lyst_it_live_it.' | translate}}
        </h6>
      </div>
    </div>
  </swiper-slide>
  <swiper-slide class="wrapper-onboarding">
    <div class="wrapper-image-onboarding">
      <img src="../assets/images/onboarding-image2.png" alt="">
      <div class="wrapper-steps-btn">
        <div class="step-btn" (click)="goToSlide(0)"></div>
        <div class="step-btn active"></div>
        <div class="step-btn" (click)="goToSlide(2)"></div>
      </div>
      <div class="wrapper-onboarding-text">
        <h1>
          {{'ONBOARDING.follow_your_favorite_lysters' | translate}}
        </h1>
        <h6>
          {{'ONBOARDING.follow_thelysts_experts_or_discover_and_connect_with_your_friends_you_never_know_what_exciting_lysts_they_might_have' | translate}}
        </h6>
      </div>
    </div>
  </swiper-slide>
  <swiper-slide class="wrapper-onboarding">
    <div class="wrapper-image-onboarding">
      <img src="../assets/images/onboarding-image3.png" alt="">
      <div class="wrapper-steps-btn">
        <div class="step-btn" (click)="goToSlide(0)"></div>
        <div class="step-btn" (click)="goToSlide(1)"></div>
        <div class="step-btn active"></div>
      </div>
      <div class="wrapper-onboarding-text">
        <h1>{{'NEW_TEXT.discover_many_more_interesting_lysts' | translate}}</h1>
        <h6>{{'NEW_TEXT.thelysts_universe_is_expansive_and_constantly_evolving_explore_your_favorite_topics_and_lysts_all_in_one_place' | translate}}.</h6>
      </div>
    </div>
  </swiper-slide>
</swiper-container>
